/**
 * Project ticket category configuration constants
 * These are used across the application to maintain consistency in project ticket category values
 */

const SECURITY_RETENTION_OPTIONS = {
	CALCULATE_SECURITY: "CALCULATE_SECURITY",
	USE_GIVEN_SECURITY: "USE_GIVEN_SECURITY",
};

const NACHTRAEGE_OPTIONS = {
	WITH_NACHTRAEGE: "WITH_NACHTRAEGE",
	WITHOUT_NACHTRAEGE: "WITHOUT_NACHTRAEGE",
};

const CALCULATION_OPTIONS = {
	CALCULATED: "CALCULATED",
	FIX: "FIX",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	SECURITY_RETENTION_OPTIONS,
	NACHTRAEGE_OPTIONS,
	CALCULATION_OPTIONS,
};
